// file: src/KalkulatorTempPovremeni.js

import React, { useState, useEffect } from 'react';
import './Kalkulator.css';
import { FiDollarSign } from 'react-icons/fi';

function KalkulatorTempPovremeni() {
  const [unosTip, setUnosTip] = useState('bruto');   // bira se unos 'bruto' ili 'neto'
  const [bruto, setBruto] = useState('');
  const [neto, setNeto] = useState('');
  const [errors, setErrors] = useState({ bruto: '', neto: '' });
  const [rezultati, setRezultati] = useState(null);
  const [submitError, setSubmitError] = useState(null);

  // Validacija jednog polja (prazno ili neg. broj)
  const validateField = (name, value) => {
    let msg = '';
    if (value.trim() === '') {
      msg = 'Ovo polje je obavezno.';
    } else if (isNaN(Number(value)) || Number(value) < 0) {
      msg = 'Unesite nenegativan broj.';
    }
    setErrors(prev => ({ ...prev, [name]: msg }));
  };

  // Kada se promijeni bruto i ako je odabrano 'bruto', zovemo backend
  useEffect(() => {
    if (unosTip === 'bruto') {
      if (bruto.trim() !== '' && errors.bruto === '') {
        const payload = { bruto: parseFloat(bruto.replace(',', '.')) };
        fetch('https://plata--kalkulator-backend-api--gklzkvjpw2s5.code.run/privremeni-povremeni/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(async (res) => {
            if (!res.ok) throw new Error('Greška pri izračunu.');
            const data = await res.json();
            setRezultati(data);
            setSubmitError(null);
          })
          .catch(err => {
            setRezultati(null);
            setSubmitError(err.message);
          });
      } else {
        setRezultati(null);
        setSubmitError(null);
      }
    }
  }, [bruto, errors.bruto, unosTip]);

  // Kada se promijeni neto i ako je odabrano 'neto', zovemo backend
  useEffect(() => {
    if (unosTip === 'neto') {
      if (neto.trim() !== '' && errors.neto === '') {
        const payload = { neto: parseFloat(neto.replace(',', '.')) };
        fetch('https://plata--kalkulator-backend-api--gklzkvjpw2s5.code.run/privremeni-povremeni/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(async (res) => {
            if (!res.ok) throw new Error('Greška pri izračunu.');
            const data = await res.json();
            setRezultati(data);
            setSubmitError(null);
          })
          .catch(err => {
            setRezultati(null);
            setSubmitError(err.message);
          });
      } else {
        setRezultati(null);
        setSubmitError(null);
      }
    }
  }, [neto, errors.neto, unosTip]);

  const handleBrutoChange = (e) => {
    const v = e.target.value.replace(',', '.');
    setBruto(v);
    validateField('bruto', v);
  };

  const handleNetoChange = (e) => {
    const v = e.target.value.replace(',', '.');
    setNeto(v);
    validateField('neto', v);
  };

  const handleUnosTipChange = (e) => {
    setUnosTip(e.target.value);
    setBruto('');
    setNeto('');
    setErrors({ bruto: '', neto: '' });
    setRezultati(null);
    setSubmitError(null);
  };

  return (
    <>
      {/* Naslov aplikacije */}
      <header className="app-header">
        <h1>
          PRIVREMENI I POVREMENI POSLOVI <br />
          <br />
          (Obračun za privremene i povremene angažmane)
        </h1>
      </header>

    <div className="container">
      {/* Lijevi dio: unos */}
      <div className="form-container card">
        <div className="form-header">
          <h2>
            Unos podataka
          </h2>
        </div>

        {/* Biranje vrste unosa (Bruto/Neto) */}
        <div className="field-group">
          <label htmlFor="unosTip" className="field-label">
            Izaberite vrstu unosa<span className="required">*</span>:
          </label>
          <select
            id="unosTip"
            className="field-select"
            value={unosTip}
            onChange={handleUnosTipChange}
          >
            <option value="bruto">Bruto</option>
            <option value="neto">Neto</option>
          </select>
        </div>

        {unosTip === 'bruto' && (
          <div className="field-group">
            <label htmlFor="bruto" className="field-label">
              Bruto<span className="required">*</span>:
            </label>
            <input
              type="text"
              id="bruto"
              className={`field-input ${errors.bruto ? 'shake' : ''}`}
              placeholder="npr. 2000,00"
              value={bruto}
              onChange={handleBrutoChange}
              onBlur={(e) => validateField('bruto', e.target.value.replace(',', '.'))}
            />
            {errors.bruto && <div className="error-text">{errors.bruto}</div>}
          </div>
        )}

        {unosTip === 'neto' && (
          <div className="field-group">
            <label htmlFor="neto" className="field-label">
              Neto<span className="required">*</span>:
            </label>
            <input
              type="text"
              id="neto"
              className={`field-input ${errors.neto ? 'shake' : ''}`}
              placeholder="npr. 1400,00"
              value={neto}
              onChange={handleNetoChange}
              onBlur={(e) => validateField('neto', e.target.value.replace(',', '.'))}
            />
            {errors.neto && <div className="error-text">{errors.neto}</div>}
          </div>
        )}
      </div>

      {/* Desni dio: prikaz rezultata */}
      <div className="results-container card">
        {rezultati && (
          <>
            <h3 className="section-title">Rezultati</h3>
            <div className="results-section">
              <div className="result-row">
                <span>Bruto:</span>
                <span>{rezultati.bruto.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Neto:</span>
                <span>{rezultati.neto.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Doprinosi:</span>
                <span>{rezultati.doprinosi.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Dohodak:</span>
                <span>{rezultati.dohodak.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Porez:</span>
                <span>{rezultati.porez.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <b><span>Ukupne obaveze:</span></b>
                <b><span>{rezultati.ukupne_obaveze.toFixed(2)}</span></b>
              </div>
            </div>
          </>
        )}
        {submitError && <div className="error-text">{submitError}</div>}
      </div>
    </div>
    </>
  );
}

export default KalkulatorTempPovremeni;
